// Buscar solo en el nombre: coincidencias de inicio primero, luego las demas, alfabeticamente.
const normalize = value => String(value ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
export const rankProductMatches = (products, query) => {
  const words = normalize(query).split(/\s+/).filter(Boolean);
  if (!words.length) return [...products].sort((a, b) => normalize(a.nombreProducto).localeCompare(normalize(b.nombreProducto), 'es'));
  const full = words.join(' ');
  return products.map((product, index) => {
    const name = normalize(product.nombreProducto);
    if (!words.every(word => name.includes(word))) return null;
    const rank = name === full ? 0 : name.startsWith(full) ? 1 : 2;
    return { product, index, rank, name };
  }).filter(Boolean)
    .sort((a, b) => a.rank - b.rank || a.name.localeCompare(b.name, 'es') || a.index - b.index)
    .map(entry => entry.product);
};
